const url = "./assets/page/steps/step6/icons/";

const options = [
    {
        content: " ",
        icon: true,
        text: "Nenhuma",
        url: `${url}aditional2_any.svg`,
    },
    {
        content: "one-tube",
        icon: true,
        text: "Um tubete",
        url: `${url}aditional2_one-tube.svg`,
    },
    {
        content: "two-tube",
        icon: true,
        text: "Dois tubetes",
        url: `${url}aditional2_two-tube.svg`,
    },
    {
        content: "kitkat",
        icon: true,
        text: "Kit Kat",
        url: `${url}aditional2_kitkat.svg`,
    },
    {
        content: "cherry",
        icon: true,
        text: "Cereja",
        url: `${url}aditional2_cherry.svg`,
    },
];

export default options;
